import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useNumberSpeech from "../hooks/useNumberSpeech";
import SEOHead from "../CommanComponents/SEOHead";
// Bileşen Importları
import useCalculateSimilarity from "../hooks/useCalculateSimilarity";
import WordsTrEngCard from "../Component/WordsTrEngCard";
import WordEngCard from "../Component/WordEngCard";
import AsistanCard from "../Component/AsistanCard";
import StudentCard from "../Component/StudentCard";
import HeaderCard from "../Component/HeaderCard";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import QuestionCard from "../Component/QuestionCard";
import CelebrationComponent from "../Component/Celebrate";
import ArrayCounter from "../Component/ArrayCounter";

function Vocabulary() {
  const [TextValue, setTextValue] = useState(0);
  const [activeLevel, setActiveLevel] = useState("Beginner");
  const [isTeacherTurn, setIsTeacherTurn] = useState(true);
  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [similarityScore, setSimilarityScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState({});
  const [completePart, setCompletePart] = useState(false);
  const [countStage, SetCountStage] = useState(1);
  const [userAnswers, setUserAnswers] = useState([]);
  const [repeatIntermediateCount, setRepeatIntermediateCount] = useState([]);
  const [taskPackage, setTaskPackage] = useState({});
  // Hata state'i eksikti, buraya eklendi
  const [error, setError] = useState("");
  const [recognition, setRecognition] = useState(null);

  // API ve Kayıt Referansları
  const contentValue = useSelector((state) => state.contents.contentValues);
  const navigate = useNavigate();
  // Hook'tan normalizeText fonksiyonunu çekiyoruz
  const { normalizeText } = useNumberSpeech();

  const levelSet = [
    { name: "Beginner", tr: "1. Adım", title: "Step 1" },
    { name: "Intermediate", tr: "2. Adım", title: "Step 2" },
    { name: "Advanced", tr: "3. Adım", title: "Step 3" },
    { name: "Exıt", tr: "cıkış", title: "Exıt" },
  ];

  const { calculateSimilarity, getFeedbackMessage, getSimilarityColor } =
    useCalculateSimilarity();

  // İçerik kontrolü
  useEffect(() => {
    if (
      !contentValue ||
      !contentValue.contents ||
      contentValue.contents.length === 0
    ) {
      console.log("İçerik boş, ana sayfaya yönlendiriliyor...");
      navigate("/");
    }
  }, [contentValue, navigate]);

  // Seviye/Soru değişiminde state sıfırlama
  useEffect(() => {
    if (activeLevel === "Advanced") {
      setIsTeacherTurn(false);
    } else {
      setIsTeacherTurn(true);
    }
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
    setError("");
  }, [TextValue, activeLevel]);

  // Web Speech API Entegrasyonu
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setError(
        "Your browser does not support Speech Recognition. Please use Google Chrome or Microsoft Edge.",
      );
      return;
    }

    const recognitionInstance = new SpeechRecognition();
    recognitionInstance.continuous = false;
    recognitionInstance.interimResults = false;
    recognitionInstance.lang = "en-US";

    recognitionInstance.onresult = (event) => {
      const rawSpokenText = event.results[0][0].transcript;
      const rawExpectedText = contentValue?.contents?.[TextValue]?.Eng || "";
      // setTranscript(spokenText);
      // Hem kullanıcının söylediğini hem de veri tabanındaki metni normalize ediyoruz
      const spokenText = normalizeText(rawSpokenText);
      const expectedText = normalizeText(rawExpectedText);

      // Kullanıcının ekranda temiz kelime halini görmesi için:
      setTranscript(spokenText);
      // const expectedText = contentValue?.contents?.[TextValue]?.Eng || "";

      // Benzerlik skoru hesaplama (Genelde 0 ile 1 arası veya 0 ile 100 arası döner, duruma göre ayarlanabilir)
      const similarity = calculateSimilarity(spokenText, expectedText);
      console.log(similarity, "benzerlik");
      setSimilarityScore(similarity);

      // %70 ve üzeri başarı kontrolü
      if (similarity >= 0.7) {
        setIsCorrect(true);
        console.log("çalıştı");
        setTimeout(() => goToNext(), 1500);
      } else {
        setIsCorrect(false);
      }
    };

    recognitionInstance.onerror = (event) => {
      setError(`Error occurred in recognition: ${event.error}`);
      setIsListening(false);
    };

    recognitionInstance.onend = () => {
      setIsListening(false);
    };

    setRecognition(recognitionInstance);

    // Temizleme fonksiyonu
    return () => {
      if (recognitionInstance) {
        recognitionInstance.abort();
      }
    };
  }, [TextValue, contentValue]);

  // Task paketi hazırlama
  useEffect(() => {
    if (completePart) {
      setTaskPackage({
        userAnswers: userAnswers,
        countStage: countStage,
        repeatIntermediateCount: repeatIntermediateCount,
      });
    }
  }, [completePart]);

  const startListening = () => {
    setError("");
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);

    // Intermediate için sayaç artırma
    if (activeLevel === "Intermediate") {
      setRepeatIntermediateCount((prev) => ({
        ...prev,
        [TextValue]: (prev[TextValue] || 0) + 1,
      }));
    }

    if (recognition) {
      try {
        recognition.start();
        setIsListening(true);
      } catch (err) {
        console.error("Recognition start error:", err);
      }
    }
  };

  const stopListening = () => {
    if (recognition) {
      try {
        recognition.stop();
      } catch (err) {
        console.error("Recognition stop error:", err);
      }
      setIsListening(false);
    }
  };

  const goToBack = () => {
    const currentText = TextValue;
    const currentStage = countStage;

    if (currentText === 0 && currentStage === 1 && activeLevel === "Beginner") {
      return;
    }

    const nextValue = currentText - 1;
    if (activeLevel === "Advanced" && nextValue < 0) {
      setActiveLevel("Intermediate");
      SetCountStage(2);
      setTextValue(contentValue.contents.length - 1);
      return;
    }

    if (nextValue >= 0) {
      setTextValue(nextValue);
    } else {
      const count = currentStage - 1;
      if (count > 0) {
        SetCountStage(count);
        setTextValue(contentValue.contents.length - 1);
      } else {
        if (activeLevel === "Advanced") {
          setActiveLevel("Intermediate");
          SetCountStage(3);
          setTextValue(contentValue.contents.length - 1);
        } else if (activeLevel === "Intermediate") {
          setActiveLevel("Beginner");
          SetCountStage(3);
          setTextValue(contentValue.contents.length - 1);
        }
      }
    }
  };

  const handleBackButton = () => {
    goToBack();
  };

  const handleNextButton = () => {
    goToNext();
  };

  const goToNext = () => {
    if (window.speechSynthesis) window.speechSynthesis.cancel();
    stopListening();

    const nextValue = TextValue + 1;

    if (
      activeLevel === "Advanced" &&
      nextValue >= contentValue.contents.length
    ) {
      setCompletePart(true);
      return;
    }

    if (nextValue < contentValue.contents.length) {
      setTextValue(nextValue);
    } else {
      const count = countStage + 1;
      if (count <= 3) {
        SetCountStage(count);
        setTextValue(0);
      } else {
        if (activeLevel === "Beginner") {
          setActiveLevel("Intermediate");
          SetCountStage(1);
        } else if (activeLevel === "Intermediate") {
          setActiveLevel("Advanced");
          SetCountStage(1);
        }
        setTextValue(0);
      }
    }
  };

  const speakText = (text) => {
    if (!("speechSynthesis" in window)) return;
    window.speechSynthesis.cancel();
    setIsSpeaking(true);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 0.9;
    utterance.onend = () => {
      setIsSpeaking(false);
      setTimeout(() => setIsTeacherTurn(false), 500);
    };
    window.speechSynthesis.speak(utterance);
  };

  const handleLevelChange = (level) => {
    if (level === "Exıt") {
      navigate("/");
      return;
    }
    setActiveLevel(level);
    setTextValue(0);
    SetCountStage(1);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
    setSelectedOption({});
  };

  const handleAnswerSelect = (option) => {
    if (selectedOption[TextValue] !== undefined) return;
    const currentQuestion = contentValue.contents[TextValue];
    const isCorrectAns = option === currentQuestion.Eng;

    setSelectedOption((prev) => ({ ...prev, [TextValue]: option }));
    setUserAnswers((prev) => [
      ...prev,
      {
        questionId: currentQuestion._id,
        question: currentQuestion.Eng,
        givenAnswer: option,
        correctAnswer: currentQuestion.Eng,
        isCorrect: isCorrectAns,
      },
    ]);
  };

  return (
    <div className="flex flex-col w-full gap-4">
      <SEOHead
        title="İngilizce Kelime Çalışması"
        description="İlkokul öğrencileri için eğlenceli ve interaktif İngilizce kelime ezberleme, kartlar ve alıştırma modülü."
      />
      {/* Hata Mesajı Gösterimi */}
      {error && (
        <div className="p-3 bg-red-100 text-red-700 rounded-xl text-sm border border-red-200">
          {error}
        </div>
      )}

      {/* celebrate */}
      <div className={`${completePart ? "block" : "hidden"}`}>
        {completePart ? (
          <CelebrationComponent
            setCompletePart={setCompletePart}
            taskPackage={taskPackage}
          />
        ) : null}
      </div>

      {/* Vocabulary */}
      <div
        className={`${completePart ? "hidden" : "block"} flex flex-col gap-4 w-full`}
      >
        {/* Header */}
        <div className="w-full">
          <HeaderCard
            handleLevelChange={handleLevelChange}
            levelSet={levelSet}
            activeLevel={activeLevel}
          />
        </div>

        {/* contents (icerikler) */}
        <div className="w-full flex flex-col p-2 bg-purple-500 rounded-2xl gap-4">
          <div>
            <div className="flex justify-between items-center">
              <BackButton handleBackButton={handleBackButton} />
              <ArrayCounter TextValue={TextValue} />
              <NextButton handleNextButton={handleNextButton} />
            </div>

            <div className="w-full bg-gradient-to-br from-purple-500 to-purple-500 rounded-b-2xl py-3 md:py-10 flex justify-center items-center flex-row gap-3 md:gap-8">
              <div className="flex flex-row gap-2 justify-center items-center">
                {contentValue?.contents?.[TextValue]?.emoji?.includes(
                  "extraEmoji/",
                ) ? (
                  <div>
                    <img
                      src={contentValue?.contents?.[TextValue]?.emoji}
                      alt=""
                      className="h-24 w-40 mr-4"
                    />
                  </div>
                ) : (
                  <div className="text-6xl md:text-9xl drop-shadow-lg">
                    {contentValue?.contents?.[TextValue]?.emoji || "📝"}
                  </div>
                )}

                {activeLevel === "Beginner" && (
                  <WordsTrEngCard
                    TextValue={TextValue}
                    activeLevel="Beginner"
                  />
                )}

                {activeLevel === "Intermediate" && (
                  <WordEngCard TextValue={TextValue} />
                )}

                {activeLevel === "Advanced" && (
                  <QuestionCard
                    TextValue={TextValue}
                    handleAnswerSelect={handleAnswerSelect}
                    selectedOption={selectedOption[TextValue]}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Konuşma kartları */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 w-full">
            {(activeLevel === "Beginner" || activeLevel === "Intermediate") && (
              <AsistanCard
                isTeacherTurn={isTeacherTurn}
                speakText={speakText}
                isSpeaking={isSpeaking}
                TextValue={TextValue}
              />
            )}

            <StudentCard
              isCorrect={isCorrect}
              TextValue={TextValue}
              startListening={startListening}
              isTeacherTurn={isTeacherTurn}
              isListening={isListening}
              transcript={transcript}
              similarityScore={similarityScore}
              getFeedbackMessage={getFeedbackMessage}
              getSimilarityColor={getSimilarityColor}
              activeLevel={activeLevel}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vocabulary;
